import React from "react"
import axios from 'axios'
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';
import sha256 from "sha256"

class SettingsPage extends React.Component {

  componentDidMount() {
    axios.get("https://nakrutkatop.com:443/api/settings", { withCredentials: true })
      .then(res => {
        setTimeout(() => {
          try {
            document.getElementById("main-content").style.opacity = 1
            document.getElementById("main-content").style.visibility = "visible"
          }
          catch { }
        }, 50)
        document.querySelector("#tokenInput").value = res.data.apiToken

      }
      )

    new MDCTextField(document.querySelector('#oldPasswordField'));
    new MDCTextField(document.querySelector('#newPasswordField'));
    new MDCRipple(document.querySelector('#changeBtn'));

    new MDCRipple(document.querySelector('#copyBtn'));
    new MDCRipple(document.querySelector('#revokeBtn'));
    new MDCTextField(document.querySelector('#tokenField'));

    document.querySelector("#tokenInput").onkeypress = () => false

    document.querySelector("#copyBtn").onclick = () => {
      document.querySelector("#tokenInput").select()
      document.querySelector("#tokenInput").setSelectionRange(0, 99999)
      document.execCommand("copy")
    }

    const snackbar = new MDCSnackbar(document.querySelector('#settingsSnackbar'));
    snackbar.openText = function (text) {
      document.querySelector("#settingsSnackbarText").innerHTML = text
      snackbar.open()
    }

    document.querySelector('#changeBtn').onclick = () => {
      axios.get(`https://nakrutkatop.com:443/api/settings/changePassword?oldPasswordHash=${sha256(document.querySelector("#oldPasswordInput").value)}&newPasswordHash=${sha256(document.querySelector("#newPasswordInput").value)}`, { withCredentials: true })
        .then(res => {
          snackbar.openText(res.data.descr)
          if (res.data.ok) {
            document.querySelector('#oldPasswordField').classList.remove("mdc-text-field--label-floating")
            document.querySelector("#oldPasswordInput").value = ""
            document.querySelector('#oldPasswordLabel').classList.remove("mdc-floating-label--float-above")
            document.querySelector('#newPasswordField').classList.remove("mdc-text-field--label-floating")
            document.querySelector("#newPasswordInput").value = ""
            document.querySelector('#newPasswordLabel').classList.remove("mdc-floating-label--float-above")
            document.querySelector('.mdc-notched-outline--notched').classList.remove("mdc-notched-outline--notched")
            document.querySelector('.mdc-notched-outline--notched').classList.remove("mdc-notched-outline--notched")
            document.querySelector('#outline1').style.width = "100%"
            document.querySelector('#outline2').style.width = "100%"
          }
        })
    }

    document.querySelector('#revokeBtn').onclick = () => {
      axios.get(`https://nakrutkatop.com:443/api/settings/revokeToken`, { withCredentials: true })
        .then(res => {
          if (!res.data.ok) return  snackbar.openText("Ошибка авторизации")
            snackbar.openText("Токен перевыпущен")
            document.querySelector("#tokenInput").value = res.data.apiToken
        })
    }

  }

  render(props) {

    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <div class="mdc-snackbar" id="settingsSnackbar">
        <div class="mdc-snackbar__surface">
          <div class="mdc-snackbar__label" role="status" aria-live="polite" id="settingsSnackbarText">
          </div>
          <div class="mdc-snackbar__actions">
            <button type="button" class="mdc-button mdc-snackbar__action">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label">Закрыть</span>
            </button>
          </div>
        </div>
      </div>
      <main className="main-content" id="main-content" style={{ opacity: "0", visibility: "hidden", transition: ".3s opacity, .3s visibility" }}>

        <h2 className="pageHeader">Настройки</h2>

        <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>

          <div className="ibox" style={{ width: "280px", flex: "0 0 280px", maxWidth: "100%", margin: "8px" }}>
            <h3 className="ibox_title">Безопасность</h3>
            <div className="ibox_content" style={{ padding: "0 16px 16px 16px" }}>


              <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon" id="oldPasswordField" style={{ width: "100%", display: "inline-flex" }}>
                <i className="fas fa-unlock mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input type="password" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="oldPasswordInput" />
                <span class="mdc-notched-outline">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch" id="outline1">
                    <span class="mdc-floating-label" id="oldPasswordLabel">Старый пароль</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span>
              </label>

              <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon" id="newPasswordField" style={{ width: "100%", display: "inline-flex" }}>
                <i className="fas fa-lock mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input type="password" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="newPasswordInput" />
                <span class="mdc-notched-outline">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch" id="outline2">
                    <span class="mdc-floating-label" id="newPasswordLabel">Новый пароль</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span>
              </label>

              <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="changeBtn" style={{ width: "100%", display: "inline-flex", height: "56px", borderRadius: "6px" }}>
                <div class="mdc-button__ripple" style={{borderRadius: "6px"}}></div>
                <i className="fas fa-sync-alt"></i>
                <span className="mdc-button__label">&nbsp;&nbsp;Сменить пароль</span>
              </button>

            </div>
          </div>


          <div className="ibox" style={{ width: "280px", flex: "0 0 280px", maxWidth: "100%", margin: "8px" }}>
            <h3 className="ibox_title">API токен</h3>
            <div className="ibox_content" style={{ padding: "0 16px 16px 16px" }}>

              <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon mdc-text-field--label-floating" id="tokenField" style={{ width: "100%", display: "inline-flex" }}>
                <i className="fas fa-key mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="tokenInput" />
                <span class="mdc-notched-outline">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch" id="outline3">
                    <span class="mdc-floating-label mdc-floating-label--float-above" id="tokenLabel">Ваш токен</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span>
              </label>

              <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="copyBtn" style={{ width: "100%", display: "inline-flex", height: "56px", marginBottom: "8px", borderRadius: "6px" }}>
                <div class="mdc-button__ripple" style={{borderRadius: "6px"}}></div>
                <i className="fas fa-copy"></i>
                <span className="mdc-button__label">&nbsp;&nbsp;Скопировать</span>
              </button>

              <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="revokeBtn" style={{ width: "100%", display: "inline-flex", height: "56px", borderRadius: "6px" }}>
                <div class="mdc-button__ripple" style={{borderRadius: "6px"}}></div>
                <i className="fas fa-redo-alt"></i>
                <span className="mdc-button__label">&nbsp;&nbsp;Перевыпустить</span>
              </button>

            </div>
          </div>

        </div>
      </main>
    </div>
  }
}

export default SettingsPage